import { App } from "vue";

const Success = {
    install(app: App, options = {}) {
        app.provide("$success", (message, options) => {
            app.config.globalProperties.$oruga.notification.open({
                message: message,
                position: 'top',
                duration: options?.duration || 5000,
                variant: 'success',
                rootClass: 'toast-notification is-success'
            });
        });
    }
}

const Error = {
    install(app: App, options = {}) {
        app.provide("$error", (message, options) => {
            app.config.globalProperties.$oruga.notification.open({
                message: message,
                position: 'top',
                duration: options?.duration || 5000,
                variant: 'danger',
                rootClass: 'toast-notification is-danger'
            });
        });
    }
}

const Warn = {
    install(app: App, options = {}) {
        app.provide("$warn", (message, options) => {
            app.config.globalProperties.$oruga.notification.open({
                message: message,
                position: 'top',
                duration: options?.duration || 5000,
                variant: 'warning',
                rootClass: 'toast-notification is-warning'
            });
        });
    }
}

export default {
    Success,
    Error,
    Warn
}